import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const maintenanceWorkflowStatus: Record<string, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Completo',
  canceled: 'Cancelado',
}

export const maintenanceWorkflowStatusOptions = strategyToOptions(maintenanceWorkflowStatus);
